export class MasterVM {
  ID: number;
  Text: number;
}
